import { useState } from 'react';
import Pagination from '../../components/Pagination';
import SearchBar from '../../components/SearchBar';
import { useLeaflet } from '../../lib/leaflet';
import HotelMapCard from './HotelMapCard';
import { useHotels } from '../../hooks/useHotels';

const LIMIT = 20;

const MISSING_FILTERS = [
  { key: 'missing', label: 'Missing coordinates' },
  { key: 'has', label: 'Has coordinates' },
  { key: 'all', label: 'All' },
];

// filter -> `missing` query param ('all' omits it)
const missingParam = (f) => (f === 'missing' ? true : f === 'has' ? false : undefined);

export default function HotelModerationPage() {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [missing, setMissing] = useState('missing'); // backlog first

  const { ready: mapsReady, error: mapsError } = useLeaflet();

  const { data, isLoading, error } = useHotels({
    page,
    limit: LIMIT,
    search,
    missing: missingParam(missing),
  });
  const rows = data?.data || [];
  const total = data?.total;

  const changeSearch = (v) => { setSearch(v); setPage(1); };
  const changeMissing = (key) => { setMissing(key); setPage(1); };

  return (
    <div className="page">
      <div className="page__header"><h1>Hotel Moderation</h1></div>

      <div className="page__toolbar page__toolbar--row">
        <SearchBar value={search} onSearch={changeSearch} placeholder="Search name, address, or city…" />
        <div className="seg">
          {MISSING_FILTERS.map((f) => (
            <button
              key={f.key}
              type="button"
              className={`seg__btn${missing === f.key ? ' seg__btn--active' : ''}`}
              onClick={() => changeMissing(f.key)}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      {mapsError && (
        <div className="state state--error" role="alert">{mapsError.message}</div>
      )}

      {isLoading ? (
        <div className="state state--loading">Loading…</div>
      ) : error ? (
        <div className="state state--error" role="alert">{error.message || 'Failed to load hotels.'}</div>
      ) : rows.length === 0 ? (
        <div className="state state--empty">No hotels found.</div>
      ) : (
        <div className="map-grid">
          {rows.map((hotel) => (
            <HotelMapCard key={hotel.id} hotel={hotel} mapsReady={mapsReady} />
          ))}
        </div>
      )}

      {data && total != null && (
        <Pagination page={page} limit={LIMIT} total={total} onPage={setPage} />
      )}
    </div>
  );
}
